<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>日志缓存管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 操作按钮组 -->
    <h2 class="el_h2">操作按钮组</h2>
    <el-row>
      <el-button
      v-if="btn_permission.includes('sys:redis:dict')||btn_permission.includes('superAdmin')"
      type="success"
      @click="redis_dict">更新字典信息缓存</el-button>
      <el-button
      v-if="btn_permission.includes('sys:redis:reloadRedisActiveRole')||btn_permission.includes('superAdmin')"
      type="infor"
      @click="reload_role">重新加载可用角色缓存</el-button>
      <el-button
      v-if="btn_permission.includes('sys:redis:activeRolePermission')||btn_permission.includes('superAdmin')"
      type="infor"
      @click="reload_permission">重新加载可用角色权限</el-button>
      <el-button
      v-if="btn_permission.includes('sys:redis:uriPermission')||btn_permission.includes('superAdmin')"
      type="infor"
      @click="reload_url">重新加载URI权限数据</el-button>
      <el-button
      v-if="btn_permission.includes('wms:redis:orderType')||btn_permission.includes('superAdmin')"
      type="primary"
      @click="update_type"
      >更新WMS订单类型缓存</el-button>
      <el-button
      v-if="btn_permission.includes('wms:redis:orderStatus')||btn_permission.includes('superAdmin')"
      type="primary"
      @click="update_status"
      >更新WMS订单状态缓存</el-button>
      <el-button
      v-if="btn_permission.includes('wms:redis:lot')||btn_permission.includes('superAdmin')"
      type="primary"
      @click="update_batch"
      >更新WMS批次属性缓存</el-button>
      <el-button
      v-if="btn_permission.includes('wms:redis:customer')||btn_permission.includes('superAdmin')"
      type="primary"
      @click="update_warehouse"
      >更新WMS货主/仓库缓存</el-button>
      <el-button
      type="success"
      @click="sync_customer"
      >同步货主</el-button>
      <el-button
      type="success"
      @click="sync_warehouse"
      >同步仓库</el-button>
    </el-row>
    <!-- 操作日志列表 -->
    <h2 class="el_h2">操作日志列表</h2>
    <el-row>
      <el-form
      ref="operate_form"
      :model="operate_form"
      label-width="80px"
      class="operate_form"
      >
        <el-form-item label="请求方式" prop="reqType">
          <el-input v-model="operate_form.reqType"></el-input>
        </el-form-item>
        <el-form-item label="操作人" prop="userName">
          <el-input v-model="operate_form.userName"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="operation_log()">搜索</el-button>
          <el-button @click="reset_operate()">重置</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-table
    v-loading="list_loading"
    :data="listData"
    highlight-current-row
    max-height="400"
    border
    >
      <el-table-column type="index" align="center" label="id"></el-table-column>
      <el-table-column min-width="200" prop="reqApi" label="请求API"></el-table-column>
      <el-table-column prop="methodDesc" label="请求描述"></el-table-column>
      <el-table-column prop="reqType" label="请求方式"></el-table-column>
      <el-table-column
      show-overflow-tooltip
      prop="parameterValues"
      label="请求参数">
        <template slot-scope="scope">
          <div @click="open_params(scope.row)">{{scope.row.parameterValues}}</div>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="result" label="请求结果"></el-table-column>
      <el-table-column prop="userName" label="操作人"></el-table-column>
      <el-table-column prop="startTime" label="开始时间"></el-table-column>
      <el-table-column fixed="right" prop="endTime" label="结束时间"></el-table-column>
      <el-table-column fixed="right" prop="costTime" label="耗时"></el-table-column>
    </el-table>
    <!-- 操作日志分页 -->
    <el-pagination
    style="margin: 10px auto;"
    background
    @size-change="pageparm_size_change"
    @current-change="pageparm_current_change"
    :current-page="pageparm.currentPage"
    :page-sizes="[10, 15, 20, 25]"
    :page-size="pageparm.pageSize"
    layout="total, sizes, prev, pager, next, jumper"
    :total="pageparm.total"
    ></el-pagination>
    <!-- 异常日志列表 -->
    <h2 class="el_h2">异常日志列表</h2>
    <el-table
    v-loading="new_list_loading"
    :data="listData_new"
    highlight-current-row
    max-height="400"
    border
    >
      <el-table-column label="id" type="index" align="center"></el-table-column>
      <el-table-column prop="reqApi" label="请求API"></el-table-column>
      <el-table-column show-overflow-tooltip prop="detail" label="详情">
        <template slot-scope="scope">
          <div @click="openDetails(scope.row)">{{scope.row.detail}}</div>
        </template>
      </el-table-column>
      <el-table-column
      show-overflow-tooltip
      prop="parameterValues"
      label="请求参数">
        <template slot-scope="scope">
          <div @click="open_parameter(scope.row)">{{scope.row.parameterValues}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="msg" label="提示信息"></el-table-column>
      <el-table-column prop="userName" label="操作人"></el-table-column>
      <el-table-column prop="addTime" label="添加时间"></el-table-column>
    </el-table>
    <!-- 异常日志分页 -->
    <el-pagination
    style="margin: 10px auto;"
    background
    @size-change="pageparms_size_change"
    @current-change="pageparms_current_change"
    :current-page="pageparms.currentPage"
    :page-sizes="[10, 15, 20, 25]"
    :page-size="pageparms.pageSize"
    layout="total, sizes, prev, pager, next, jumper"
    :total="pageparms.total"
    ></el-pagination>
    <!-- 操作日志列表-请求参数弹框 -->
    <el-dialog
    :append-to-body="true"
    :visible.sync="params_show"
    :title="params_title"
    :close-on-click-modal='false'
    >
      <div style="font-size: 20px;">{{params_main}}</div>
    </el-dialog>
    <!-- 异常日志列表-详情弹框 -->
    <el-dialog
    :append-to-body="true"
    :visible.sync="details_show"
    :title="details_title"
    :close-on-click-modal='false'
    >
      <div v-html="details_main" style="height: 500px;overflow-y: scroll;font-size: 20px;"></div>
    </el-dialog>
    <!-- 异常日志列表-请求参数弹框 -->
    <el-dialog
    :append-to-body="true"
    :visible.sync="parameter_show"
    :title="parameter_title"
    :close-on-click-modal="false"
    >
      <div style="font-size: 20px;">{{parameter_main}}</div>
    </el-dialog>
  </div>
</template>

<script>
  import Pagination from '../Pagination'
  import Paginations from '../Pagination_new'
  export default {
    data() {
      return{
        btn_permission:JSON.parse(localStorage.getItem(localStorage.getItem('userName')+'permission')),
        listData:[],//操作日志列表
        //操作日志列表懒加载
        list_loading:false,
        //操作日志分页
        pageparm:{
          currentPage: 1,
          pageSize: 25,
          total: 10
        },
        //操作日志查询表单
        operate_form:{
          reqType:'',
          userName:''
        },
        listData_new:[],//异常日志列表
        //日常日志列表懒加载
        new_list_loading:false,
        //异常日志分页
        pageparms:{
          currentPage: 1,
          pageSize: 25,
          total: 10
        },
        //操作日志列表请求参数弹框
        params_title:'',
        params_show:false,
        params_main:'',
        //异常日志列表详情弹框
        details_title:'',
        details_show:false,
        details_main:'',
        //异常日志列表请求参数弹框
        parameter_title:'',
        parameter_show:false,
        parameter_main:''
      }
    },
    // 注册组件
    components: {
      Pagination,
      Paginations
    },
    created() {
      let that=this
      that.publicAjax.axios_set()
      //操作日志列表
      that.operation_log()
      //异常日志列表
      that.exception_log()
    },
    mounted() {

    },
    methods:{
	  //操作日志列表分页
	  pageparm_size_change(val){
	    this.pageparm.pageSize=val
	    //操作日志列表
	    this.operation_log()
	  },
	  pageparm_current_change(val){
	    this.pageparm.currentPage=val
	    //操作日志列表
	    this.operation_log()
	  },
      //操作日志列表
      operation_log(){
        let that=this
        that.list_loading=true
        that.$axios.get(that.publicAjax.extra_path+'/admin/log/operationList',{
          params:{
            page:that.pageparm.currentPage,
            limit:that.pageparm.pageSize,
            reqType:that.operate_form.reqType,
            userName:that.operate_form.userName,
            startTime:that.operate_form.startTime
          }
        }).then(data=>{
          that.list_loading=false
          if(data.data.success==true){
            //获取当前用户按钮权限
            that.$axios({
              method:'get',
              url:that.publicAjax.extra_path+'/admin/user/permission'
            }).then(data=>{
              if(data.data.success==true){
                that.btn_permission=data.data.data
              }else{
                that.$message.error(data.data.message)
              }
            })
            that.listData=data.data.data.list
            that.pageparm.total=data.data.data.total
          }else{
            that.$message.error(data.data.message)
          }
        })
      },
      //重置操作日志表单查询
      reset_operate(){
        this.$refs['operate_form'].resetFields()
        this.pageparm.currentPage=1
        this.pageparm.pageSize=25
        //操作日志列表
        this.operation_log()
      },
	  //异常日志列表分页
	  pageparms_size_change(val){
	    this.pageparms.pageSize=val
	    //异常日志列表
	    this.exception_log()
	  },
	  pageparms_current_change(val){
	    this.pageparms.currentPage=val
	    //异常日志列表
	    this.exception_log()
	  },
      //异常日志列表
      exception_log(){
        let that=this
        that.new_list_loading=true
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/admin/log/exceptionList?page='+that.pageparms.currentPage+'&limit='+that.pageparms.pageSize
        }).then(data=>{
          that.new_list_loading=false
          if(data.data.success==true){
            that.listData_new=data.data.data.list
            that.pageparms.total=data.data.data.total
          }else{
            that.$message.error(data.data.message)
          }
        })
      },
      //公共函数
      update_fn(url){
        let that=this
        that.$axios({
          method:'put',
          url:that.publicAjax.extra_path+url
        }).then(data=>{
          if(data.data.success==true){
            that.$message.success(data.data.message)
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //更新字典信息缓存
      redis_dict(){
        this.update_fn('/admin/dict/redis')
      },
      //重新加载可用角色缓存
      reload_role(){
        this.update_fn('/admin/role/redis/reloadRedisActiveRole')
      },
      //重新加载可用角色权限
      reload_permission(){
        this.update_fn('/admin/role/redis/activeRolePermission')
      },
      //重新加载URI权限数据
      reload_url(){
        this.update_fn('/admin/permission/redis/uriPermission')
      },
      //更新WMS订单类型缓存
      update_type(){
        this.update_fn('/wms/orderBase/updateOrderTypeForRedis')
      },
      //更新WMS订单状态缓存
      update_status(){
        this.update_fn('/wms/orderBase/updateOrderStatusForRedis')
      },
      //更新WMS批次属性缓存
      update_batch(){
        this.update_fn('/wms/orderBase/updateWmsLotForRedis')
      },
      //更新WMS货主/仓库缓存
      update_warehouse(){
        this.update_fn('/wms/customer/updateWmsCustomerForRedis')
      },
      //同步货主
      sync_customer(){
        this.update_fn('/middle/warehouseCustomer/synchronized')
      },
      //同步仓库
      sync_warehouse(){
        this.update_fn('/middle/warehouse/synchronized')
      },
      //操作日志列表请求参数弹框
      open_params(row){
        this.params_show=true
        this.params_title='请求API '+row.reqApi+' 的请求参数'
        this.params_main=row.parameterValues
      },
      //异常日志列表详情弹框
      openDetails(row){
        this.details_show=true
        this.details_title='请求API '+row.reqApi+' 的详情'
        this.details_main=row.detail.replace(/\n/g,'<br>')
      },
      //异常日志列表请求参数弹框
      open_parameter(row){
        this.parameter_show=true
        this.parameter_title='请求API '+row.reqApi+' 的请求参数'
        this.parameter_main=row.parameterValues
      }
    }
  }
</script>

<style scoped="scoped">
  .el_h2{
    border-left: 4px solid #409EFF;
    padding: 10px;
    margin: 20px 0;
    font-size: 16px;
    background: #F5F7FA;
  }
  .el-row .el-button{
    margin-bottom: 5px;
  }
  .el-button+.el-button{
    margin-left: auto;
  }
  .operate_form .el-form-item{
    width: 32%;
    display: inline-block;
  }
  @media screen and (max-width:720px) {
    .operate_form .el-form-item{
      width: 100%;
    }
  }
</style>
<style>
  .el-tooltip__popper{
    max-width:30%;
    display: -webkit-box;
    padding-bottom: 10px !important;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 15;
    -webkit-box-orient: vertical;
  }
</style>



// WEBPACK FOOTER //
// src/components/set/buffer_manage.vue